module.exports = __webpack_public_path__ + "static/media/bed.1508b595.svg";